import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  fileDeleteHandler,
  siteActiveInactive,
  siteDetail,
  updateSite,
  uploadFileToS3,
  uploadSiteImage,
} from "../action";
import { useFormik } from "formik";
import { updateSitesSchema } from "../../../utils/validationSchema";
import CustomInputField from "../../../components/customInputField";
import UpdateSiteImageUpload from "../../../components/updateSiteImgUpload/index";
import { updateSiteInitialValue } from "../../../utils/initialValues";
import toast from "react-hot-toast";
import { DIVE_TYPES } from "../../../utils/contentTypes";
import GoogleAutComplete from "../../../components/googleAutocomplete";
import MapComponent from "../../../components/googleAutocomplete/MapComponent";
import ProperSpinner from "../../../components/spinner/ProperSpinner";
import {
  extractLatLngCountry,
  getDeleteImageKey,
} from "../../../utils/commonFunctions";
import Spinner from "../../../components/spinner";
import CustomModal from "../../../components/customModal";
import { MdVerifiedUser } from "react-icons/md";
import { RxCrossCircled } from "react-icons/rx";
import { Box, Button, Modal, Stack } from "@mui/material";
import { ERROR_TOAST } from "../../../utils/showToast";
import { FaMapMarkerAlt } from "react-icons/fa";
import EditSiteAsyncAutocompleteEditSite from "../../../components/customAutocomplete/EditSiteAutocomplete";
// import AsyncAutocomplete from "../../../components/customAutocomplete";
// import AsyncAutocompleteEditSite from "../../../components/customAutocomplete/AsyncAutocompleteEditSite";
// import AsyncAutocompleteEditSite from "../../../components/customAutocomplete/AsyncAutocompleteEditSite";

/**
 * @function UpdateDetail
 * @description for UpdateDetail of site
 * @returns JSX for UpdateDetail
 */

const UpdateDetail = () => {
  const { siteId } = useParams();
  const dispatch = useDispatch();
  const [site, setSite] = useState({});
  const [loading, setLoading] = useState(false);
  const [prevFiles, setPrevFiles] = useState([]);
  const [currFiles, setCurrFiles] = useState([]);
  const [initialFiles, setInitailFiles] = useState([]);
  const [defaultImageIndex, setDefaultImageIndex] = useState(0);
  const [modal, setModal] = useState(false);
  const [mapModal, setModalMap] = useState(false);
  const [latLng, setLatLng] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
  const [countryForSearchCity, setCountryForSearchCity] = useState("");
  const [selectedCity, setSelectedCity] = useState({});
  const [initialCity, setInitialCity] = useState({});
  const navigate = useNavigate();

  const modalClose = () => {
    setModal(false);
  };

  const isActiveHandler = (id, status) => {
    if (status === 1) {
      dispatch(
        siteActiveInactive({ status: 2 }, `?siteId=${id}`, (response) => {
          setSite((prev) => ({ ...prev, status: 2 }));
        })
      );
    } else {
      dispatch(
        siteActiveInactive({ status: 1 }, `?siteId=${id}`, (response) => {
          setSite((prev) => ({ ...prev, status: 1 }));
        })
      );
    }
    modalClose();
  };

  const renderModalBody = (status) => {
    return (
      <div>
        <p>
          Are you sure want to{" "}
          <span className="highlight--text">
            {status == 2 ? "Activate" : "Deactivate"}
          </span>{" "}
          this site?{" "}
        </p>
      </div>
    );
  };

  const defaultImageIndexHandler = (index) => {
    if (index === defaultImageIndex) setDefaultImageIndex(0);
    else setDefaultImageIndex(index);
  };

  const prevFileHandler = (data) => {
    setPrevFiles(data);
  };
  const currFileHandler = (data) => {
    setCurrFiles(data);
  };
  const addressHandler = (data) => {
    if (!data) return;
    setLatLng({
      lat: data.lat || "",
      lng: data.lng || "",
    });
    setSelectedLocation({
      addressLine: data.addressLine || "",
      lat: data.lat || "",
      lng: data.lng || "",
      country: data.country || "",
    });
  };

  const addressHandlerFromSelectedCity = (city) => {
    if (!city) {
      siteData.setFieldValue("city", "");
      siteData.setFieldValue("state", "");
      siteData.setFieldValue("country", "");
      return;
    } else {
      const { cityName = "", state = "", country = "" } = city;
      siteData.setFieldValue("city", cityName || "");
      siteData.setFieldValue("state", state || "");
      siteData.setFieldValue("country", country || "");
    }
  };

  const longitude =
    site?.siteAddress?.coordinates?.[0] ?? site?.siteAddress?.latitude;
  const latitude =
    site?.siteAddress?.coordinates?.[1] ?? site?.siteAddress?.longitude;

  // Prepare the initial value object
  const initialValue = {
    siteName: site?.siteName,
    description: site?.description,
    ...site?.siteAddress,
    latitude,
    longitude,
    isRecommend: site?.isRecommend,
    isBestDestination: site?.isBestDestination,
    diveType: site?.diveType,
    maxDepth: site?.maxDepth,
    // defaultImage: site?.defaultImage,
  };

  if (initialValue?.coordinates) delete initialValue.coordinates;

  const getImageCrediantial = () => {
    const filesName = currFiles.map((file, index) => {
      function replaceFileNameWithUserId(fileName, userId) {
        // Extract the file extension using a regular expression
        const extensionMatch = fileName.match(/\.[^/.]+$/);
        const extension = extensionMatch ? extensionMatch[0] : "";

        // Return the new file name using the user ID and the original extension
        return `${userId}${extension}`;
      }
      return replaceFileNameWithUserId(file.name, index);
    });

    dispatch(
      uploadSiteImage(
        {
          folderType: 4,
          files: filesName,
        },
        (response) => {
          if (!response.isSuccess) {
            setLoading(false);
          } else uploadFileToS3Handler(response.data);
        }
      )
    );
  };
  const uploadFileToS3Handler = async (fileResponses) => {
    try {
      delete fileResponses.message;
      let responses = Object.values(fileResponses).filter((item) => item.url);
      let uploadedFiles = [];
      let unUploadedFiles = [];
      const uploadPromises = responses.map(
        (res, index) =>
          new Promise((resolve, reject) => {
            dispatch(
              uploadFileToS3(currFiles[index], res, (response) => {
                if (response.error) {
                  reject(response.error);
                  unUploadedFiles.push(response);
                } else {
                  uploadedFiles.push(response.imageUrl);
                  responses[index] = response.imageUrl;
                  resolve(response);
                }
              })
            );
          })
      );
      const results = await Promise.allSettled(uploadPromises);
      results.forEach((result, index) => {
        if (result.status === "rejected") {
          console.error(
            `Error in uploading file at position ${index}:`,
            result.reason
          );
        } else {
          console.log(`Successfully uploaded  ${index} file`, result.value);
        }
      });

      if (uploadedFiles.length > 0) {
        updateSiteHandler([...prevFiles, ...uploadedFiles]);
      } else {
        setLoading(false);
        toast.error("No files were uploaded successfully.");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error in File Upload:", error);
    }
  };

  const deleteFiles = async (imageKeys) => {
    try {
      const deletePromises = imageKeys.map((key) => {
        return new Promise((resolve, reject) => {
          dispatch(
            fileDeleteHandler(key, (response) => {
              if (response.error) {
                reject(response.error);
              } else resolve(response);
            })
          );
        });
      });
      const result = await Promise.allSettled(deletePromises);
    } catch (error) {
      console.log("Error in Delete Files :", error);
    }
  };
  const updateSiteHandler = (images) => {
    const deletedImagesKeys = getDeleteImageKey(images, initialFiles);
    // debugger;
    deleteFiles(deletedImagesKeys);

    // dispatch()

    const defaultImgUrl = images[defaultImageIndex];
    images.splice(defaultImageIndex, 1);
    const siteAddress = {
      ...siteData.values,
    };
    delete siteAddress.siteName;
    delete siteAddress.description;
    delete siteAddress.isRecommend;
    delete siteAddress.isBestDestination;
    delete siteAddress.maxDepth;
    delete siteAddress.diveType;

    const dataToSend = {
      siteAddress: {
        ...siteAddress,
        postalCode: String(siteAddress.postalCode),
      },
      isRecommend: siteData.values.isRecommend,
      isBestDestination: siteData.values.isBestDestination,
      siteName: siteData.values.siteName,
      description: siteData.values.description,
      siteImages: [...images],
      maxDepth: siteData.values.maxDepth,
      diveType: siteData.values.diveType,
      defaultImage: defaultImgUrl,
    };

    dispatch(
      updateSite(siteId, dataToSend, (response) => {
        setLoading(false);
        if (response?.isSuccess) {
          navigate("/sites");
        }
      })
    );
  };

  const siteData = useFormik({
    initialValues: initialValue || updateSiteInitialValue,
    enableReinitialize: true,
    validationSchema: updateSitesSchema,
    onSubmit: () => {
      if (currFiles.length + prevFiles.length < 2) {
        toast.error(
          "At least 2 image is required. default image and other site images"
        );
      } else if (currFiles.length + prevFiles.length > 20) {
        toast.error("At max you can upload 20 images");
      } else {
        setLoading(true);
        if (currFiles.length > 0) {
          getImageCrediantial();
        } else {
          updateSiteHandler(prevFiles);
        }
      }
    },
  });

  useEffect(() => {
    setLoading(true);
    dispatch(
      siteDetail(`?siteId=${siteId}`, (response) => {
        setSite(response);
        setLoading(false);
        setPrevFiles([response?.defaultImage, ...response?.siteImages]);
        setInitailFiles([response?.defaultImage, ...response?.siteImages]);
        console.log("response in site detail:", response);
        setLatLng({
          lng: response?.siteAddress?.coordinates[0] || "",
          lat: response?.siteAddress?.coordinates[1] || "",
        });
        setCountryForSearchCity(response?.siteAddress?.country || "");
        setSelectedCity({
          cityName: response?.siteAddress?.city || "",
          state: response?.siteAddress?.state || "",
          country: response?.siteAddress?.country || "",
          // pinCodes: [response?.siteAddress?.postalCode] || [],
          _id: response?.siteAddress?._id || "",
        });
      })
    );
  }, []);

  return (
    <>
      {loading && (
        <div className="spinner-container">
          <Spinner />
        </div>
      )}
      <div className="add-sites-wrapper">
        <div className="header--container">
          <h3 className="w-50 mb-0 text-primary">{"Update Site"}</h3>
          {site && site.status && (
            <div
              onClick={() => setModal(true)}
              className={`site-details-btns ${site?.status === 2 ? "site-success-btn" : "site-warning-btn"}`}
            >
              {site.status === 2 ? "Activate" : "Deactivate"}
              {site?.status === 2 ? (
                <MdVerifiedUser className="lg-icon" />
              ) : (
                <RxCrossCircled className="lg-icon" />
              )}
            </div>
          )}
        </div>
        <div className="user-details-main-container">
          <div className="user-details-container-1 ">
            <div>
              <CustomInputField
                label={"Site name"}
                changeHandler={siteData.handleChange}
                name={"siteName"}
                placeholder={"Enter site name"}
                type={"text"}
                value={siteData.values.siteName}
                blurhandler={siteData.handleBlur}
              />
              {siteData.errors.siteName && siteData.touched.siteName && (
                <div className="change-password-error">
                  {siteData.errors.siteName}
                </div>
              )}
            </div>
            <div>
              <label htmlFor="description" className="lable-text">
                {"Description"}
              </label>
              <textarea
                id="desc"
                name="description"
                value={siteData.values.description}
                onChange={siteData.handleChange}
                rows="16"
                cols="50"
                className="form-control"
                placeholder="Enter site description"
                onBlur={siteData.handleBlur}
                style={{ resize: "none" }}
              ></textarea>
              {siteData.errors.description && siteData.touched.description && (
                <div className="change-password-error">
                  {siteData.errors.description}
                </div>
              )}
            </div>
          </div>

          <div className="user-details-container-2 ">
            {/* Profile Section */}
            <div className="personal-info-container">
              <h4 className="label-text heading text-underline ">
                {"Address Information"}
              </h4>

              <div>
                <Modal
                  open={mapModal}
                  onClose={() => setModalMap(false)}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    p: 2,
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: "background.paper",
                      borderRadius: 2,
                      boxShadow: 24,
                      p: 3,
                      width: "90%",
                      maxWidth: 700,
                      display: "flex",
                      flexDirection: "column",
                      gap: 2,
                    }}
                  >
                    {/* Google Autocomplete */}
                    <GoogleAutComplete addressHandler={addressHandler} />

                    {/* Map */}
                    <Box
                      className="map-wrapper"
                      sx={{
                        height: 400,
                        borderRadius: 2,
                        overflow: "hidden",
                        border: "1px solid #ddd",
                      }}
                    >
                      <MapComponent
                        latLng={latLng}
                        setLatLng={(val) => {
                          setLatLng({ lat: val.lat, lng: val.lng });
                        }}
                        completeInfoOfCurrentLocation={(val) => {
                          console.log("value of address :", val);
                          const addressToSave = extractLatLngCountry(val);
                          console.log("addressToSave:", addressToSave);
                          if (addressToSave.country === null) {
                            ERROR_TOAST(
                              "No Country found for this location, please select another location."
                            );
                          }
                          console.log("addressToSave:", addressToSave);
                          setSelectedLocation({
                            addressLine: addressToSave.addressLine || "",
                            lat: addressToSave.lat || "",
                            lng: addressToSave.lng || "",
                            country: addressToSave.country || "",
                          });
                        }}
                      />
                    </Box>

                    {/* Buttons */}
                    <Stack
                      direction="row"
                      spacing={2}
                      justifyContent="flex-end"
                    >
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => setModalMap(false)}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          console.log("reset foam called");
                          siteData.resetForm();
                          siteData.setFieldValue("state", "");
                          siteData.setFieldValue("city", "");
                          siteData.setFieldValue("postalCode", "");
                          siteData.setFieldValue("addressLine1", "");
                          setSelectedCity(null);
                          siteData.setFieldValue(
                            "addressLine2",
                            selectedLocation.addressLine
                          );
                          siteData.setFieldValue(
                            "latitude",
                            selectedLocation.lat
                          );
                          siteData.setFieldValue(
                            "longitude",
                            selectedLocation.lng
                          );
                          siteData.setFieldValue(
                            "country",
                            selectedLocation.country
                          );
                          setCountryForSearchCity(selectedLocation.country);
                          setModalMap(false);
                        }}
                      >
                        Save Location
                      </Button>
                    </Stack>
                  </Box>
                </Modal>
                <div className=" d-flex justify-content-between ">
                  <div className="mb-2">
                    <label className="form-label fw-bold d-block">
                      Select Site Coordinates
                    </label>
                    <small className="text-muted d-block mb-2">
                      Choose your location on Google Map
                    </small>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => setModalMap(true)}
                    >
                      <FaMapMarkerAlt className="me-2" />
                      Open Map
                    </button>
                  </div>
                  {siteData.values.latitude &&
                    siteData.values.longitude &&
                    (() => {
                      const staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${siteData.values.latitude},${siteData.values.longitude}&zoom=14&size=900x200&markers=color:red%7C${siteData.values.latitude},${siteData.values.longitude}&key=${googleMapsApiKey}`;
                      const mapLink = `https://www.google.com/maps/search/?api=1&query=${siteData.values.latitude},${siteData.values.longitude}`;
                      console.log("lat :", siteData.values.latitude);
                      console.log("lng :", siteData.values.longitude);
                      return (
                        <div style={{ width: "60%", height: "130px" }}>
                          <a
                            href={mapLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ overflow: "hidden" }}
                          >
                            <img
                              src={staticMapUrl}
                              alt="Map showing location"
                              // className="map-image"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                              }}
                            />
                          </a>
                          {!countryForSearchCity.length && (
                            <div className="change-password-error">
                              {
                                "No Country found for this location, please select another location."
                              }
                            </div>
                          )}
                        </div>
                      );
                    })()}
                </div>

                <CustomInputField
                  changeHandler={siteData.handleChange}
                  label={"Address 1"}
                  name={"addressLine1"}
                  placeholder={"Enter address 1"}
                  value={siteData.values.addressLine1}
                  type={"text"}
                  blurhandler={siteData.handleBlur}
                />
                {siteData.errors.addressLine1 &&
                  siteData.touched.addressLine1 && (
                    <div className="change-password-error">
                      {siteData.errors.addressLine1}
                    </div>
                  )}
              </div>

              <div>
                <CustomInputField
                  // disabledPropery={isGetAddress.addressLine2}
                  readyOnly={true}
                  changeHandler={siteData.handleChange}
                  label={"Address 2"}
                  name={"addressLine2"}
                  placeholder={"Enter address 2"}
                  value={siteData.values.addressLine2}
                  type={"text"}
                  blurhandler={siteData.handleBlur}
                />
                {siteData.errors.addressLine2 &&
                  siteData.touched.addressLine2 && (
                    <div className="change-password-error">
                      {siteData.errors.addressLine2}
                    </div>
                  )}
              </div>

              {/*  city and postal code */}
              <div className="info-child-container ">
                <div
                  className="info-sub-child-container "
                  style={{ paddingBottom: "5px" }}
                >
                  <div className="add-city-input-field-container">
                    <EditSiteAsyncAutocompleteEditSite
                      isInitialCity={true}
                      disabled={countryForSearchCity ? false : true}
                      onSelect={(value) => {
                        addressHandlerFromSelectedCity(value);
                        console.log("value in on select:", value);
                      }}
                      selected={selectedCity}
                      setSelected={(val) => {
                        setSelectedCity(val);
                        console.log("selected city:", val);
                      }}
                      name="city"
                      placeHolder="Search city name"
                      value={siteData.values.city}
                      changeHandler={(val) => {
                        console.log("change called ", val);
                        siteData.setFieldValue("city", val);
                      }}
                      blurhandler={siteData.handleBlur}
                      label={"City"}
                      url={
                        countryForSearchCity
                          ? `?pageNo=1&limit=10&country=${countryForSearchCity}`
                          : `?pageNo=1&limit=10`
                      }
                    />
                  </div>

                  {siteData.errors.city && siteData.touched.city && (
                    <div className="change-password-error">
                      {siteData.errors.city}
                    </div>
                  )}
                </div>

                <div className="info-sub-child-container">
                  <label className="lable-text" htmlFor="diveType">
                    {"Postal Code"}
                  </label>
                  <select
                    name="postalCode"
                    id="postalCode"
                    value={siteData.values.postalCode}
                    onChange={siteData.handleChange}
                    className="form-select form-select-md"
                    aria-label="Select Postal Code"
                    blurhandler={siteData.handleBlur}
                    disabled={!selectedCity?.pinCodes?.length}
                  >
                    <option value="">{"Select Postal Code"}</option>
                    {selectedCity?.pinCodes?.map((code, index) => (
                      <option key={index} value={code}>
                        {code}
                      </option>
                    ))}
                  </select>

                  {siteData.errors.postalCode &&
                    siteData.touched.postalCode && (
                      <div className="change-password-error">
                        {siteData.errors.postalCode}
                      </div>
                    )}
                </div>
              </div>

              <div className="info-child-container ">
                <div className="info-sub-child-container">
                  <CustomInputField
                    readyOnly={true}
                    changeHandler={siteData.handleChange}
                    label={"State"}
                    name={"state"}
                    placeholder={"Enter state"}
                    value={siteData.values.state}
                    type={"text"}
                    blurhandler={siteData.handleBlur}
                  />
                  {siteData.errors.state && siteData.touched.state && (
                    <div className="change-password-error">
                      {siteData.errors.state}
                    </div>
                  )}
                </div>
                <div className="info-sub-child-container">
                  <CustomInputField
                    readyOnly={true}
                    changeHandler={siteData.handleChange}
                    label={"Country"}
                    name={"country"}
                    placeholder={"Enter country"}
                    value={siteData.values.country}
                    type={"text"}
                    blurhandler={siteData.handleBlur}
                  />
                  {siteData.errors.country && siteData.touched.country && (
                    <div className="change-password-error">
                      {siteData.errors.country}
                    </div>
                  )}
                </div>
              </div>

              {/* Latitude and logintude */}
              <div className="info-child-container ">
                <div className="info-sub-child-container">
                  <CustomInputField
                    changeHandler={siteData.handleChange}
                    label={"Longitude"}
                    name={"longitude"}
                    placeholder={"Enter Longitude"}
                    value={siteData.values.longitude}
                    type={"number"}
                    blurhandler={siteData.handleBlur}
                    readyOnly={true}
                  />
                  {siteData.errors.longitude && siteData.touched.longitude && (
                    <div className="change-password-error">
                      {siteData.errors.longitude}
                    </div>
                  )}
                </div>
                <div className="info-sub-child-container">
                  <CustomInputField
                    changeHandler={siteData.handleChange}
                    label={"Latitude"}
                    name={"latitude"}
                    placeholder={"Enter latitude"}
                    value={siteData.values.latitude}
                    type={"number"}
                    blurhandler={siteData.handleBlur}
                    readyOnly={true}
                  />
                  {siteData.errors.latitude && siteData.touched.latitude && (
                    <div className="change-password-error">
                      {siteData.errors.latitude}
                    </div>
                  )}
                </div>
              </div>

              {/* dive types and max depth */}
              <div className="info-child-container ">
                <div className="info-sub-child-container">
                  <CustomInputField
                    changeHandler={siteData.handleChange}
                    label={"Max Depth (meter)"}
                    name={"maxDepth"}
                    placeholder={"Enter max depth"}
                    value={siteData.values.maxDepth}
                    type={"number"}
                    blurhandler={siteData.handleBlur}
                  />
                  {siteData.errors.maxDepth && siteData.touched.maxDepth && (
                    <div className="change-password-error">
                      {siteData.errors.maxDepth}
                    </div>
                  )}
                </div>
                <div className="info-sub-child-container">
                  <label className="lable-text" htmlFor="diveType">
                    {"Dive Types"}
                  </label>
                  <select
                    name="diveType"
                    id="diveType"
                    value={siteData.values.diveType}
                    onChange={siteData.handleChange}
                    onBlur={siteData.handleBlur}
                    className="form-select form-select-md"
                    aria-label="Select Dive Type"
                  >
                    <option value="">Select Dive Type</option>
                    {Object.entries(DIVE_TYPES).map(([key, value]) => (
                      <option key={value} value={value}>
                        {key}
                      </option>
                    ))}
                  </select>

                  {siteData.errors.diveType && siteData.touched.diveType && (
                    <div className="change-password-error">
                      {siteData.errors.diveType}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <UpdateSiteImageUpload
          defaultImageIndex={defaultImageIndex}
          defaultImageIndexHandler={defaultImageIndexHandler}
          currFiles={currFiles}
          currFilesHanlder={currFileHandler}
          prevFiles={prevFiles}
          prevFileHandler={prevFileHandler}
        />

        {/* {siteData.values.latitude && siteData.values.longitude && (
          <div className="map-wrapper">
            <MapComponent
              latLng={{
                lng: siteData.values.latitude,
                lat: siteData.values.longitude,
              }}
            />
          </div>
        )} */}

        <div className="update-site-bottom-btn-container ">
          <div className="d-flex align-items-center justify-center gap-4 ">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                name="isBestDestination"
                id="defaultCheck1"
                checked={siteData.values.isBestDestination}
                onChange={(e) =>
                  siteData.setFieldValue("isBestDestination", e.target.checked)
                }
              />
              <label className="form-check-label" htmlFor="defaultCheck1">
                {"Is BestDestination"}
              </label>
            </div>
            <div className="form-check ">
              <input
                className="form-check-input"
                type="checkbox"
                id="defaultCheck2"
                name="isRecommend"
                checked={siteData.values.isRecommend}
                onChange={(e) =>
                  siteData.setFieldValue("isRecommend", e.target.checked)
                }
              />
              <label className="form-check-label" htmlFor="defaultCheck2">
                {"Is Recommend"}
              </label>
            </div>
            <button
              disabled={
                JSON.stringify(initialValue) ===
                  JSON.stringify(siteData.values) &&
                currFiles.length === 0 &&
                JSON.stringify(initialFiles) === JSON.stringify(prevFiles) &&
                defaultImageIndex === 0
              }
              // type="submit"
              className="btn btn-primary  user-details-btns"
              onClick={siteData.handleSubmit}
            >
              {"Save"}
            </button>
          </div>
        </div>
        <CustomModal
          visible={modal}
          visibleHandler={modalClose}
          heading={"Confirmation"}
          body={() => renderModalBody(site?.status)}
          confirmHandler={() =>
            // block_unblock_handler(userDetails?._id, userDetails?.status)
            isActiveHandler(site?._id, site?.status)
          }
          modalSize="small"
          confirmText={site?.status == 2 ? "Yes, Activate" : "Yes, Deactivate"}
          footershow={true}
          closeText="Cancel"
        />
      </div>
    </>
  );
};

export default UpdateDetail;
